<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import ProductService from '@/services/product'
import { productColor } from '@/utils/product'

export default {
  page: {
    title: "Produtos Mais Vendidos",
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Produtos Mais Vendidos",
      products: [],
      searchValue: '',

      count: 0,
      currentCount: 0,
      currentPage: 1,
      totalPages: 0,
      perPage: 0,
      startIndex: 0,
      endIndex: 0,
    }
  },
  computed: {
    rows() {
      return this.products.length;
    }
  },
  mounted() {
    this.load(1);
  },
  methods: {
    productColor,
    load(page) {
      let loader = this.$loading.show();

      ProductService.getProductsSales(page, this.searchValue).then(res => {
        loader.hide();

        this.products = res.data.data;

        this.count = res.data.count;
        this.currentCount = res.data.currentCount;
        this.currentPage = res.data.currentPage;
        this.totalPages = res.data.totalPages;
        this.perPage = res.data.perPage;
        this.startIndex = res.data.startIndex;
        this.endIndex = res.data.endIndex;
      }).catch(() => {
        loader.hide();
      })
    },
    onPageChange() {
      this.load(this.currentPage);
    },
    search() {
      this.load(1);
    },
    changeSearch() {
      if (this.searchValue === '' && !this.searchEmptyField) {
        this.searchEmptyField = true;
        this.load(true, 1, this.searchValue);
      }
    },
    exportData() {
      let loader = this.$loading.show();

      ProductService.downloadProductSalesReport().then(res => {
        loader.hide();

        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');

        fileLink.href = fileURL;
        fileLink.setAttribute('download', `lista-produtos-mais-vendidos.csv`);
        document.body.appendChild(fileLink);

        fileLink.click();
      }).catch(() => {
        loader.hide();
      })
    }
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title"/>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-12 text-right">
                <button class="btn btn-rounded btn-outline-secondary" @click="exportData">
                  Exportar Dados
                </button>
              </div>
            </div>
            <!-- Table data -->
            
            <div class="table-responsive mb-0">
              <table class="table table-centered">
                <thead class="thead-light">
                  <tr>
                    <th>Código SKU</th>
                    <th>Descrição</th>
                    <th>Carrinho</th>
                    <th>Vendas</th>
                    <th>Cliques</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="data in products" :key="data._id">
                    <td>{{data.sku}}</td>
                    <td>
                      {{data.description}}
                      <p class="text-muted mb-0 mt-1 font-size-10" v-if="productColor(data)">Cor: {{productColor(data)}}</p>
                    </td>
                    <td>{{data.stats ? data.stats.cart : ''}}</td>
                    <td>{{data.stats ? data.stats.sale : ''}}</td>
                    <td>{{data.stats ? data.stats.view : ''}}</td>
                  </tr>
                </tbody>
              </table>

              <b-modal
                id="modal-remove"
                title="Excluir Produto?"
                title-class="font-18"
                centered
              >
                <p>Confirma a exclusão do produto?</p>

                <div slot="modal-footer">
                  <b-btn variant="link" @click="$bvModal.hide('modal-remove')" class="mr-3">Cancelar</b-btn>
                  <b-btn variant="primary" @click="removeProduct">Excluir</b-btn>
                </div>
              </b-modal>
            </div>  
            
            <div class="row justify-content-md-between align-items-md-center mt-4">
              <div class="col-xl-7">Mostrando {{startIndex}} - {{endIndex}} de {{count}}</div>

              <div class="col-xl-5">
                <div class="text-md-right float-xl-right mt-2 pagination-rounded">
                  <b-pagination
                    v-model="currentPage" 
                    :total-rows="count"
                    :per-page="perPage"
                    @input="onPageChange"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->

    <!-- <div class="row" v-if="loading">
      <div class="col-12">
        <div class="text-center my-3">
          <a href="javascript:void(0);" class="text-primary">
            <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
          </a>
        </div>
      </div>
    </div> -->
  </Layout>
</template>

<style lang="scss">
  .search-box form {
    display: flex;
    flex-direction: row;
  }

  .search-box .form-control {
    padding-left: 20px;
  }

  .input-search {
    width: 90%;
  }
</style>